import { ReactElement } from 'react';
import { ReportColumns } from '@/pages/Reports/DynamicReport/components/ReportTable/utils';
import Table from '@/common/Table';

export type TrainingReportPdfTableHeaderProps = {
  columns: ReportColumns;
  keys: string[];
};

const TrainingReportPdfTableHeader = ({ columns, keys }: TrainingReportPdfTableHeaderProps): ReactElement => (
  <Table.Row header>
    {keys.map((key) => (
      <Table.Cell className={key.toUpperCase()} key={key}>
        {columns[key]?.value as string}
      </Table.Cell>
    ))}
  </Table.Row>
);

export default TrainingReportPdfTableHeader;
